module.exports = __webpack_public_path__ + "static/img/nothing.7d96f499.png";